import { render, staticRenderFns } from "./iqFieldTextArea.vue?vue&type=template&id=fb9a1202&scoped=true&"
import script from "./iqFieldTextArea.vue?vue&type=script&lang=js&"
export * from "./iqFieldTextArea.vue?vue&type=script&lang=js&"
import style0 from "./iqFieldTextArea.vue?vue&type=style&index=0&id=fb9a1202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9a1202",
  null
  
)

component.options.__file = "iqFieldTextArea.vue"
export default component.exports